(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.board = initialState;
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "hasEmptyTile",
            value: function hasEmptyTile() {
                for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
                    if (this.board[r][c] === 0) return true;
                }
                return false;
            }
        },
        {
            key: "generateNewTitle",
            value: function generateNewTitle() {
                if (!this.hasEmptyTile()) return;
                var found = false;
                while(!found){
                    var r = Math.floor(Math.random() * 4);
                    var c = Math.floor(Math.random() * 4);
                    if (this.board[r][c] === 0) {
                        this.board[r][c] = 2;
                        var tile = document.getElementById(r.toString() + "-" + c.toString());
                        tile.innerText = "2";
                        tile.classList.add("x2");
                        found = true;
                    }
                }
            }
        },
        {
            key: "boardsEqual",
            value: function boardsEqual(b1, b2) {
                for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
                    if (b1[r][c] !== b2[r][c]) return false;
                }
                return true;
            }
        },
        {
            key: "render",
            value: function render() {
                var cells = document.querySelectorAll(".field-cell");
                if (!cells.length) return;
                var index = 0;
                for(var row = 0; row < 4; row++)for(var col = 0; col < 4; col++){
                    var value = this.board[row][col];
                    var cell = cells[index];
                    cell.textContent = value !== 0 ? value : "";
                    cell.className = "field-cell";
                    if (value !== 0) cell.classList.add("field-cell--".concat(value));
                    else cell.classList.add("field-cell--empty");
                    index++;
                }
                var scoreElement = document.querySelector(".game-score");
                if (scoreElement) scoreElement.textContent = this.score;
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(row) {
                    var newRow = _this.board[row].filter(function(x) {
                        return x !== 0;
                    });
                    for(var i = 0; i < newRow.length - 1; i++)if (newRow[i] === newRow[i + 1]) {
                        newRow[i] *= 2;
                        newRow[i + 1] = 0;
                        _this.score += newRow[i];
                    }
                    newRow = newRow.filter(function(x) {
                        return x !== 0;
                    });
                    while(newRow.length < 4)newRow.push(0);
                    _this.board[row] = newRow;
                };
                for(var row = 0; row < 4; row++)_loop(row);
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(row) {
                    var newRow = _this.board[row].filter(function(x) {
                        return x !== 0;
                    });
                    for(var i = newRow.length - 1; i > 0; i--)if (newRow[i] === newRow[i - 1]) {
                        newRow[i] *= 2;
                        newRow[i - 1] = 0;
                        _this.score += newRow[i];
                    }
                    newRow = newRow.filter(function(x) {
                        return x !== 0;
                    });
                    while(newRow.length < 4)newRow.unshift(0);
                    _this.board[row] = newRow;
                };
                for(var row = 0; row < 4; row++)_loop(row);
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(col) {
                    var colData = [];
                    for(var row = 0; row < 4; row++)colData.push(_this.board[row][col]);
                    var newCol = colData.filter(function(x) {
                        return x !== 0;
                    });
                    for(var i = 0; i < newCol.length - 1; i++)if (newCol[i] === newCol[i + 1]) {
                        newCol[i] *= 2;
                        newCol[i + 1] = 0;
                        _this.score += newCol[i];
                    }
                    newCol = newCol.filter(function(x) {
                        return x !== 0;
                    });
                    while(newCol.length < 4)newCol.push(0);
                    for(var row1 = 0; row1 < 4; row1++)_this.board[row1][col] = newCol[row1];
                };
                for(var col = 0; col < 4; col++)_loop(col);
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(col) {
                    var colData = [];
                    for(var row = 0; row < 4; row++)colData.push(_this.board[row][col]);
                    var newCol = colData.filter(function(x) {
                        return x !== 0;
                    });
                    for(var i = newCol.length - 1; i > 0; i--)if (newCol[i] === newCol[i - 1]) {
                        newCol[i] *= 2;
                        newCol[i - 1] = 0;
                        _this.score += newCol[i];
                    }
                    newCol = newCol.filter(function(x) {
                        return x !== 0;
                    });
                    while(newCol.length < 4)newCol.unshift(0);
                    for(var row1 = 0; row1 < 4; row1++)_this.board[row1][col] = newCol[row1];
                };
                for(var col = 0; col < 4; col++)_loop(col);
            }
        },
        {
            key: "isGameOver",
            value: function isGameOver() {
                for(var row = 0; row < 4; row++)for(var col = 0; col < 4; col++){
                    var current = this.board[row][col];
                    if (current === 0) return false;
                    if (col < 3 && current === this.board[row][col + 1]) return false;
                    if (row < 3 && current === this.board[row + 1][col]) return false;
                }
                return true;
            }
        },
        {
            key: "isWin",
            value: function isWin() {
                for(var row = 0; row < 4; row++)for(var col = 0; col < 4; col++){
                    if (this.board[row][col] === 2048) return true;
                }
                return false;
            }
        },
        {
            key: "handleKey",
            value: function handleKey(key) {
                if (this.status !== "playing") return;
                var oldBoard = this.board.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                switch(key){
                    case "ArrowLeft":
                        this.moveLeft();
                        break;
                    case "ArrowRight":
                        this.moveRight();
                        break;
                    case "ArrowUp":
                        this.moveUp();
                        break;
                    case "ArrowDown":
                        this.moveDown();
                        break;
                    default:
                        return;
                }
                var boardChanged = !this.boardsEqual(oldBoard, this.board);
                if (boardChanged) {
                    this.generateNewTitle();
                    this.render();
                    if (this.isWin() && this.status !== "win") {
                        var _document_querySelector;
                        this.status = "win";
                        (_document_querySelector = document.querySelector(".message-win")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.remove("hidden");
                    } else if (this.isGameOver()) {
                        var _document_querySelector1;
                        this.status = "lose";
                        (_document_querySelector1 = document.querySelector(".message-lose")) === null || _document_querySelector1 === void 0 ? void 0 : _document_querySelector1.classList.remove("hidden");
                    }
                }
            }
        },
        {
            key: "start",
            value: function start() {
                var _document_querySelector, _document_querySelector1, _document_querySelector2;
                this.board = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.score = 0;
                this.status = "playing";
                (_document_querySelector = document.querySelector(".message-start")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.classList.add("hidden");
                (_document_querySelector1 = document.querySelector(".message-win")) === null || _document_querySelector1 === void 0 ? void 0 : _document_querySelector1.classList.add("hidden");
                (_document_querySelector2 = document.querySelector(".message-lose")) === null || _document_querySelector2 === void 0 ? void 0 : _document_querySelector2.classList.add("hidden");
                this.generateNewTitle();
                this.generateNewTitle();
                this.render();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.start();
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
document.addEventListener("DOMContentLoaded", function() {
    var startButton = document.querySelector(".button.start");
    // Додаємо ID для кожної клітинки (0-0, 0-1, ..., 3-3)
    var rows = document.querySelectorAll(".field-row");
    rows.forEach(function(row, rowIndex) {
        var cells = row.querySelectorAll(".field-cell");
        cells.forEach(function(cell, colIndex) {
            cell.id = "".concat(rowIndex, "-").concat(colIndex);
        });
    });
    // Обробка натискання "Start"
    startButton.addEventListener("click", function() {
        $197cd56b15c33885$var$game.restart();
        startButton.classList.remove("start");
        startButton.classList.add("restart");
        startButton.textContent = "Restart";
    });
    // Обробка натискання клавіш
    document.addEventListener("keydown", function(e) {
        $197cd56b15c33885$var$game.handleKey(e.key);
    });
});

})();
//# sourceMappingURL=index.79ba62f8.js.map
